<template>
    <div class="balance">
        <Head :headInfo='headInfo' @onClickLeft='onBack' />
        <div class="total">
            <div class="line"><span>满返余额</span><span class="f40 colFF7A45">¥{{ rebateBalance.totalBalance | NumFormat }}</span></div>
            <div class="line"><span>总满返</span><span>¥{{ rebateBalance.totalRebateAmount | NumFormat }}</span></div>
        </div>
        <div class="content" v-for="(item, index) in rebateBalance.merchantRebates" :key="index" @click="onBill(item)">
            <div class="title"><span><img src="../../../assets/img/b2b/icon_home.png" />{{ item.merchantName }}</span><span class="colFF7A45">账单<van-icon name="arrow" /></span></div>
            <div class="list">
                <div class="head">
                    <div class="line"><span>满返余额</span><span>¥{{ item.totalBalance | NumFormat }}</span></div>
                    <div class="line"><span>总满返</span><span>¥{{ item.totalRebateAmount | NumFormat }}</span></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Head from '../../common/head'
import { myRebateBalance } from '../api/api'
export default {
    name: 'repayBalance',
    components: {
        Head
    },
    data () {
        return {
            headInfo: {
                title: '满返余额'
            },
            userInfo: {},
            rebateBalance: {}
        }
    },
    methods: {
        onBack () {
            this.$router.go(-1)
        },
        onBill (item) {
            this.$router.push({ path: '/b2b/repay/repayBill', query: { merchantCode: item.merchantCode, merchantName: item.merchantName } })
        },
        async initData () {
            const { data } = await myRebateBalance({
                memberCode: this.userInfo.companyCode
            })
            this.rebateBalance = data
        }
    },
    mounted () {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.initData()
    }
}
</script>
<style lang="scss" scoped>
.balance {
    .total {
        padding: 32px;
        background: #fff;
        font-size: 28px;
        color: #000;
        .line {
            color: #999;
            &:not(:last-child) {
                color: #000;
                margin-bottom: 32px;
            }
        }
    }
    .content {
        background: #fff;
        margin-top: 20px;
        .title {
            font-size: 28px;
            color: #000;
            padding: 32px;
            /* border-bottom: 1px solid #ededf0; */
            position: relative;
            display: flex;
            align-items: center;
            justify-content: space-between;
            img {
                width: 40px;
                height: 40px;
                margin-right: 24px;
            }
            span:last-child {
                font-size: 24px;
                display: flex;
                align-content: center;
                align-items: center;
            }
            span:first-child {
                display: flex;
                align-items: center;
            }
        }
        .list {
            padding: 0 32px 32px;
            .head {
                padding-top: 32px;
                border-top: 1px solid #ededf0;
                .line {
                    font-size: 26px;
                    color: #999;
                    &:not(:last-child) {
                        margin-bottom: 16px;
                    }
                }
            }
        }
    }
    .line {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
}
</style>